<div id="city-map" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h1 class="title">City Map</h1>
    <p class="inner-lead mt-3">
      Use the interactive map below to explore Sirsa city and find Shah Satnam Ji Girls' College easily. The college is located near Dera Sacha Sauda on the National Highway.
    </p>

    <hr class="divider">

    <div class="mt-3 rounded overflow-hidden" style="height: 500px;">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d110009.8!2d74.9695!3d29.5370!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3912012a43c46879%3A0x22f4fb29f2f0a41a!2sSirsa%2C%20Haryana!5e0!3m2!1sen!2sin!4v1620000000000!5m2!1sen!2sin"
        width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy"
        referrerpolicy="no-referrer-when-downgrade">
      </iframe>
    </div>

  </div>
</div>
